import { FC } from 'react';
import { IoPersonAddOutline } from 'react-icons/io5';

import { AvatarGroup, Text, Tooltip } from '@mantine/core';

import { Manufacturer, User } from 'models';

import { Avatar } from 'components/avatar/Avatar';
import { ProjectMetaItem } from 'components/project-overview/components';

const MAX_SHOWN_USERS = 12;

export const ProjectTeaserCollaborators: FC<{
    users?: User[];
    manufacturers?: Manufacturer[];
    isLoading?: boolean;
}> = ({ users = [], manufacturers = [], isLoading = false }) => {
    const show = users.length + manufacturers.length > 0;

    return (
        <ProjectMetaItem
            label={
                show ? (
                    <AvatarGroup spacing="xs" style={{ flexWrap: 'wrap' }}>
                        {users.slice(0, MAX_SHOWN_USERS).map((user) => (
                            <Avatar tooltip user={user} size={30} key={user.id} />
                        ))}

                        {manufacturers.map((manufacturer) => (
                            <Avatar tooltip company={manufacturer} size={30} key={manufacturer.id} />
                        ))}
                        {users.length > MAX_SHOWN_USERS && (
                            <Text fz={9} my="auto">
                                + {users.length - MAX_SHOWN_USERS} more
                            </Text>
                        )}
                    </AvatarGroup>
                ) : null
            }
            emptyLabel={isLoading ? 'loading...' : '[no collaborators]'}
        />
    );
};
